import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Megaphone, X } from '@phosphor-icons/react';
import { apiPath } from '../config/apiBase';

const API = apiPath('/api/announcements');

function authHeaders() {
  const token = localStorage.getItem('token');
  return { withCredentials: true, headers: { Authorization: `Bearer ${token}` } };
}

/**
 * Shows targeted announcements once per user after login.
 * Close (X) dismisses permanently for that user.
 */
export default function AnnouncementPopup() {
  const [queue, setQueue] = useState([]);
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/pending`, authHeaders())
      .then((res) => {
        if (!cancelled) setQueue(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setQueue([]);
      });
    return () => { cancelled = true; };
  }, []);

  const current = queue[0] || null;

  const dismiss = async () => {
    if (!current || dismissing) return;
    setDismissing(true);
    try {
      await axios.post(`${API}/${current.announcement_id}/dismiss`, {}, authHeaders());
    } catch {
      // Still remove locally so the user can continue using the app.
    }
    setQueue((q) => q.slice(1));
    setDismissing(false);
  };

  if (!current) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="announcement-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(17, 24, 39, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '480px',
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.18)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 18px',
            borderBottom: '1px solid #E5E7EB',
            background: '#F8FAFC',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingRight: '8px' }}>
            <Megaphone size={22} color="#002FA7" weight="fill" />
            <h2
              id="announcement-title"
              style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#111827' }}
            >
              {current.title || 'Announcement'}
            </h2>
          </div>
          <button
            type="button"
            onClick={dismiss}
            disabled={dismissing}
            aria-label="Close announcement"
            style={{
              border: 'none',
              background: 'transparent',
              cursor: dismissing ? 'wait' : 'pointer',
              padding: '4px',
              display: 'flex',
              flexShrink: 0,
            }}
          >
            <X size={22} color="#6B7280" weight="bold" />
          </button>
        </div>

        <div style={{ padding: '18px', fontSize: '14px', lineHeight: 1.55, color: '#374151', whiteSpace: 'pre-wrap' }}>
          {current.message}
        </div>
      </div>
    </div>
  );
}
